
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoPayTermCodeDialog extends Serenity.EntityDialog<PoPayTermCodeRow, any> {
        protected getFormKey() { return PoPayTermCodeForm.formKey; }
        protected getIdProperty() { return PoPayTermCodeRow.idProperty; }
        protected getLocalTextPrefix() { return PoPayTermCodeRow.localTextPrefix; }
        protected getNameProperty() { return PoPayTermCodeRow.nameProperty; }
        protected getService() { return PoPayTermCodeService.baseUrl; }
        protected getDeletePermission() { return PoPayTermCodeRow.deletePermission; }
        protected getInsertPermission() { return PoPayTermCodeRow.insertPermission; }
        protected getUpdatePermission() { return PoPayTermCodeRow.updatePermission; }

        protected form = new PoPayTermCodeForm(this.idPrefix);

        protected afterLoadEntity(): void {
            var Id = this.entity.Id
            if (Id == 1) {
                // this.applyChangesButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);

                // Serenity.EditorUtils.setReadOnly(this.form.StkAdjDesc, true);

            }

        }

    }
}